import { find, kebabCase } from 'lodash'

function getClientId (clients = null, idOrSlug = null) {
  if (Number.isInteger(parseInt(idOrSlug)) || idOrSlug === 'global-overview') {
    return idOrSlug
  } else {
    return find(clients, client => kebabCase(client.long_name) === idOrSlug).id
  }
}

export {
  getClientId
}
